import { IconMapPin, IconTrain } from '~/components'
import { twMerge } from '~/lib/utils'

type OfficeInfoCardProps = {
  imageSrc: string
  officeName: string
  address: string
  transportationInfo: string
  className?: string
}

export const OfficeContactInfoCard = ({
  imageSrc,
  officeName,
  address,
  transportationInfo,
  className,
}: OfficeInfoCardProps) => {
  return (
    <div
      className={twMerge(
        'flex flex-row rounded border border-grayBtn p-4',
        className,
      )}
    >
      <img
        alt={`${officeName}の画像`}
        className="h-21 w-[122px] shrink-0 object-cover"
        src={imageSrc}
      />
      <div className="flex min-w-0 flex-col gap-y-0.5 px-2">
        <p className="flex-wrap text-xs font-bold leading-[130%] text-textPrimary">
          {officeName}
        </p>
        <div className="flex flex-row items-center gap-x-1">
          <div className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-[51px] bg-brand-bg">
            <IconMapPin className="h-[14px] w-[14px]" color="brand" />
          </div>
          <p className="truncate text-[12px]">{address}</p>
        </div>
        <div className="flex flex-row items-center gap-x-1">
          <div className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-[51px] bg-brand-bg">
            <IconTrain className="h-[14px] w-[14px]" color="brand" />
          </div>
          <p className="truncate text-[12px]">{transportationInfo}</p>
        </div>
      </div>
    </div>
  )
}
